import gsap from 'gsap';
import { setCookie, cookieExists } from 'cookies-utils';

export default () => {
  let cookieName = 'db_cookie_consent';
  let button = document.querySelector('.consent-button');

  if (button) {
    let animation = gsap.to('#cookie-consent', {
      display: 'block',
      translateY: 0,
      duration: 0.2,
      ease: 'power2.in',
      paused: true
    });

    if (!cookieExists(cookieName)) {
      animation.play();
    }

    button.addEventListener('click', () => {
      setCookie({
        name: cookieName,
        value: 'true-on-' + new Date().toISOString().slice(0, 10),
        maxAge: 60 * 60 * 24 * 90,
        expires: new Date(2050, 12, 31),
        path: '/'
      })

      animation.reverse();
    })
  }
}
